// extracted by css-extract-rspack-plugin
export default {"BehaviorOptionIcon":"Rli2l","Icon":"z33Ty","isSelected":"xz_a0"};